import React, { useEffect, useState } from 'react';
import { TimerIcon } from 'lucide-react';
const START_SECONDS = 17 * 60 + 34;
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(s => s <= 1 ? START_SECONDS : s - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const h = Math.floor(remaining / 3600);
  const m = Math.floor(remaining % 3600 / 60);
  const s = remaining % 60;
  const units = [{
    v: h,
    l: 'Hours'
  }, {
    v: m,
    l: 'Minutes'
  }, {
    v: s,
    l: 'Seconds'
  }];
  return <div className="w-full max-w-xl rounded-2xl border-2 border-danger/30 bg-danger-50 p-4 text-center" role="timer" aria-live="off" data-id="element-22" data-mp="1adsgant73pyv">
      <p className="flex items-center justify-center gap-2 text-sm font-bold uppercase text-danger" data-id="element-23" data-mp="15fqwg0ny3mmc">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="34onuq6r29z9k" />
        Promotional price ends in
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-25" data-mp="2zpui0gjlmcag">
        {units.map((u, i) => <React.Fragment key={u.l} data-id="element-26" data-mp="1c31fxilr54fe" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-27" data-mp="1h01l7ras235g">
              <span className="min-w-[64px] rounded-xl bg-navy px-2 py-2 font-display text-3xl font-extrabold tabular-nums text-white sm:text-4xl" data-id="element-28" data-mp="1gxf34xq9g58z">
                {String(u.v).padStart(2, '0')}
              </span>
              <span className="mt-1 text-[11px] font-semibold uppercase text-ink-muted" data-id="element-29" data-mp="1ur6gyib0ybai">{u.l}</span>
            </div>
            {i < units.length - 1 && <span className="pt-2 font-display text-3xl font-extrabold text-navy" data-id="element-30" data-mp="1zoy4z18jtd9f">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}